import styles from './index.module.scss';

export type ChangeItem = {
	description: string;
	oldAmount: string;
	newAmount: string;
	oldChecked: boolean;
	newChecked: boolean;
	oldCurrency?: string;
	newCurrency?: string;
};

function formatAmount(val: string): string {
	if (val === '—' || val === '') return val;
	const num = Number(val);
	if (!Number.isNaN(num)) {
		return num.toFixed(2);
	}
	return val;
}

type Props = {
	list: ChangeItem[];
	variant: 'old' | 'new';
};

export default function DefaultEarningsDeductionsChangeCell({
	list,
	variant,
}: Props) {
	if (!list.length) return <>—</>;

	return (
		<div className={styles.defaultChangeCell}>
			{list.map((c) => {
				const amountChanged = c.oldAmount !== c.newAmount;
				const checkedChanged = c.oldChecked !== c.newChecked;
				const amount =
					variant === 'old' ? formatAmount(c.oldAmount) : formatAmount(c.newAmount);
				const checked = variant === 'old' ? c.oldChecked : c.newChecked;

				const amountClass =
					variant === 'old'
						? amountChanged
							? styles['defaultChangeCell__value--removed']
							: styles['defaultChangeCell__value--unchanged']
						: amountChanged
							? styles['defaultChangeCell__value--added']
							: styles['defaultChangeCell__value--unchanged'];

				const checkedClass =
					variant === 'old'
						? checkedChanged
							? styles['defaultChangeCell__value--removed']
							: styles['defaultChangeCell__value--unchanged']
						: checkedChanged
							? styles['defaultChangeCell__value--added']
							: styles['defaultChangeCell__value--unchanged'];

				const currencyChanged = (c.oldCurrency ?? '') !== (c.newCurrency ?? '');
				const currency = variant === 'old' ? c.oldCurrency : c.newCurrency;
				const currencyClass =
					variant === 'old'
						? currencyChanged
							? styles['defaultChangeCell__value--removed']
							: styles['defaultChangeCell__value--unchanged']
						: currencyChanged
							? styles['defaultChangeCell__value--added']
							: styles['defaultChangeCell__value--unchanged'];

				return (
					<div key={c.description} className={styles.defaultChangeCell__item}>
						<div className={styles.defaultChangeCell__description}>
							{c.description}
						</div>
						<div className={styles.defaultChangeCell__row}>
							Amount: <span className={amountClass}>{amount}</span>
						</div>
						<div className={styles.defaultChangeCell__row}>
							Checked: <span className={checkedClass}>{checked ? 'Yes' : 'No'}</span>
						</div>
						{currency && (
							<div className={styles.defaultChangeCell__row}>
								Currency: <span className={currencyClass}>{currency}</span>
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
}
